module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('label')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.item[_vm.addLanguageSuffix('label')]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.addLanguageSuffix('label'), $$v)
      },
      expression: "item[addLanguageSuffix('label')]"
    }
  })], 1), _vm._v(" "), (_vm.allow_submenu) ? _c('el-form-item', {
    attrs: {
      "label": "Dodaj menu rozwijane"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Menu rozwijane",
      "value": !(!!_vm.item.link)
    },
    on: {
      "change": function($event) {
        return _vm.changeMenuItemType(_vm.item)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.link) ? _c('link-component', {
    attrs: {
      "errors": _vm.errors['link']
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  }) : _c('div', [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.item.submenu), function(subitem, i) {
    return _c('el-collapse-item', {
      key: i,
      staticClass: "formset__item formset__item--nested"
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (subitem.label_pl || 'Nowy element podmenu')),
        "errors": _vm.checkForErrors(_vm.errors.submenu, [i]),
        "items": _vm.item.submenu,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.item, "submenu", $event)
        }
      }
    })], 1), _vm._v(" "), _c('submenu-item', {
      attrs: {
        "itemKey": subitem.id || subitem.randomHash,
        "errors": (_vm.errors.submenu && _vm.errors.submenu[i]) || {},
        "item": subitem
      },
      on: {
        "update:item": function($event) {
          subitem = $event
        }
      }
    })], 2)
  }), 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSubmenuItem
    }
  }, [_vm._v("Dodaj pozycję w submenu")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59fbf646"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Menus/MenuItem.vue
// module id = 760
// module chunks = 0